import { render, staticRenderFns } from "./DashboardLayout.vue?vue&type=template&id=4977e71c&scoped=true&"
import script from "./DashboardLayout.vue?vue&type=script&lang=js&"
export * from "./DashboardLayout.vue?vue&type=script&lang=js&"
import style0 from "./DashboardLayout.vue?vue&type=style&index=0&id=4977e71c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4977e71c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/__w/ddv-home/ddv-home/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4977e71c')) {
      api.createRecord('4977e71c', component.options)
    } else {
      api.reload('4977e71c', component.options)
    }
    module.hot.accept("./DashboardLayout.vue?vue&type=template&id=4977e71c&scoped=true&", function () {
      api.rerender('4977e71c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/DashboardLayout.vue"
export default component.exports